import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

export default InputRange;
